"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highlight2 = _interopRequireDefault(require("highlight.js"));

var _marked = _interopRequireDefault(require("marked"));

var _staticMarkdown = _interopRequireDefault(require("./staticMarkdown.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_marked["default"].setOptions({
  highlight: function highlight(code) {
    return _highlight2["default"].highlightAuto(code).value;
  }
});

var StaticMarkdown = function StaticMarkdown(_ref) {
  var content = _ref.content;
  return _react["default"].createElement("article", {
    className: "markdown-body"
  }, _react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _marked["default"])(content)
    }
  }));
};

StaticMarkdown.propTypes = {
  content: _propTypes["default"].string
};
StaticMarkdown.defaultProps = {
  content: ''
};
var _default = StaticMarkdown;
exports["default"] = _default;